import { FC } from "react";
import "./style.scss";

interface IRedLineForTitle {
  title: string;
  //   isTabs: boolean;
}

const RedLineForTitle: FC<IRedLineForTitle> = ({ title }) => {
  return (
    <div className="default-title">
      <p>{title}</p>
      <div className="default-title-red-line">
        <div className="default-title-red-line-body"></div>
      </div>
    </div>
  );
};
export default RedLineForTitle;
